import { INTAKE_QUESTIONS, SELLER_REASON_LABELS } from "./intake-copy";
export const OWNERSHIP_DURATION_KEY = "ownership_duration";
export const SELL_MOTIVATION_KEY = "sell_motivation";
export const SELLER_BUSINESS_TYPE_LABEL = "What kind of business do you own?";

export const OWNERSHIP_DURATION_LABEL = "How long have you owned the business?";
export const SELL_MOTIVATION_LABEL = INTAKE_QUESTIONS.sell_motivation.label;

export const SELL_MOTIVATION_OPTIONS = [
  {
    id: "considering_retirement",
    label: SELLER_REASON_LABELS.considering_retirement,
    value: "considering_retirement",
  },
  {
    id: "received_offer",
    label: SELLER_REASON_LABELS.received_offer,
    value: "received_offer",
  },
  {
    id: "just_curious",
    label: SELLER_REASON_LABELS.just_curious,
    value: "just_curious",
  },
  {
    id: "planning_transition",
    label: SELLER_REASON_LABELS.planning_transition,
    value: "planning_transition",
  },
] as const;

export type SellerQuestionRole = "ownership_duration" | "sell_motivation";

const OWNERSHIP_LABELS = new Set([
  "how long have you owned the business",
  "how long have you owned it",
]);

const MOTIVATION_LABELS = new Set([
  "whats prompting you to explore this",
  "whats making you think about selling",
  "whats prompting you to explore selling",
  "whats prompting you to explore selling your business",
  "what is prompting you to explore this",
  "what is prompting you to explore selling",
]);

export function classifySellerIntakeQuestion(field: {
  fieldKey: string;
  label: string;
}): SellerQuestionRole | null {
  if (
    field.fieldKey === OWNERSHIP_DURATION_KEY ||
    field.fieldKey === "years_owned" ||
    field.fieldKey === "yearsowned"
  ) {
    return "ownership_duration";
  }
  if (
    field.fieldKey === SELL_MOTIVATION_KEY ||
    field.fieldKey === "sell_reason"
  ) {
    return "sell_motivation";
  }
  const label = normalizeQuestionLabel(field.label);
  if (OWNERSHIP_LABELS.has(label)) return "ownership_duration";
  if (MOTIVATION_LABELS.has(label)) return "sell_motivation";
  return null;
}

/** Convert a free-text seller question into the default control, when it matches. */
export function upgradePlanForSellerField(field: {
  fieldKey: string;
  label: string;
  kind: string;
}):
  | { role: "ownership_duration"; kind: "duration" }
  | {
      role: "sell_motivation";
      kind: "multiple_choice";
      allowMultiple: true;
      required: true;
      options: Array<(typeof SELL_MOTIVATION_OPTIONS)[number]>;
    }
  | null {
  if (field.kind !== "short_answer") return null;
  const role = classifySellerIntakeQuestion(field);
  if (role === "ownership_duration") {
    return { role, kind: "duration" };
  }
  if (role === "sell_motivation") {
    return {
      role,
      kind: "multiple_choice",
      allowMultiple: true,
      required: true,
      options: [...SELL_MOTIVATION_OPTIONS],
    };
  }
  return null;
}

/**
 * A new lead-ad email is recorded without a code. An email that already
 * belongs to an account must confirm the inbox before the request is attached,
 * so a stranger cannot file inquiries in that person's name.
 */
export function deferredIntakeIdentity(
  accountExists: boolean,
): { status: "start"; emailVerified: false } | { status: "code_required" } {
  if (accountExists) return { status: "code_required" };
  return { status: "start", emailVerified: false };
}

export function normalizeQuestionLabel(label: string): string {
  return label
    .toLowerCase()
    .replace(/[’‘]/g, "'")
    .replace(/'/g, "")
    .replace(/[?!.,]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}
